export enum RoleId {
  LIST_PUBLISHER = 'list-publisher',
}

export interface RoleCodeById {
  [roleId: string]: string;
}
